import { render, staticRenderFns } from "./ProductoSeleccionado.vue?vue&type=template&id=285b5763&scoped=true&"
import script from "./ProductoSeleccionado.vue?vue&type=script&lang=js&"
export * from "./ProductoSeleccionado.vue?vue&type=script&lang=js&"
import style0 from "./ProductoSeleccionado.vue?vue&type=style&index=0&id=285b5763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b5763",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCarousel,VCarouselItem,VCol,VContainer,VLayout,VRow,VSnackbar,VTextField})
